/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetIsBrandDeletable200ResponseReasons } from './GetIsBrandDeletable200ResponseReasons';
import {
    GetIsBrandDeletable200ResponseReasonsFromJSON,
    GetIsBrandDeletable200ResponseReasonsFromJSONTyped,
    GetIsBrandDeletable200ResponseReasonsToJSON,
    GetIsBrandDeletable200ResponseReasonsToJSONTyped,
} from './GetIsBrandDeletable200ResponseReasons';

/**
 * 
 * @export
 * @interface GetIsBrandDeletable200Response
 */
export interface GetIsBrandDeletable200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetIsBrandDeletable200Response
     */
    deletable: boolean;
    /**
     * 
     * @type {GetIsBrandDeletable200ResponseReasons}
     * @memberof GetIsBrandDeletable200Response
     */
    reasons: GetIsBrandDeletable200ResponseReasons;
}

/**
 * Check if a given object implements the GetIsBrandDeletable200Response interface.
 */
export function instanceOfGetIsBrandDeletable200Response(value: object): value is GetIsBrandDeletable200Response {
    if (!('deletable' in value) || value['deletable'] === undefined) return false;
    if (!('reasons' in value) || value['reasons'] === undefined) return false;
    return true;
}

export function GetIsBrandDeletable200ResponseFromJSON(json: any): GetIsBrandDeletable200Response {
    return GetIsBrandDeletable200ResponseFromJSONTyped(json, false);
}

export function GetIsBrandDeletable200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIsBrandDeletable200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'deletable': json['deletable'],
        'reasons': GetIsBrandDeletable200ResponseReasonsFromJSON(json['reasons']),
    };
}

export function GetIsBrandDeletable200ResponseToJSON(json: any): GetIsBrandDeletable200Response {
    return GetIsBrandDeletable200ResponseToJSONTyped(json, false);
}

export function GetIsBrandDeletable200ResponseToJSONTyped(value?: GetIsBrandDeletable200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deletable': value['deletable'],
        'reasons': GetIsBrandDeletable200ResponseReasonsToJSON(value['reasons']),
    };
}

